const project_type = ["one-shot", "recurring", "cost-based", "hour-pack", 'pre-sale']
export default {
  status: ["open", "to_be_invoiced", "completed"],
  project_type
};
